import React from 'react';
import './Bjstandard.css';
import bstandar from '../../../imgs/bstandard.webp';

const Bjstandard = () => {
    return (
        <div className="Ordinary-container">
            <div className='Ordinarys'>
                <h2 className="Ordinary-title">BJ Standard Servo Energy-saving Injection Molding Machine</h2>

                <div className="Ordinary-content">
                                            <ul className="Ordinary-text">
                            <li>Fast response and high precision;</li>
                            <li>Short molding cycle and high efficiency;</li>
                            <li>Servo system, energy saving up to 80%;</li>
                            <li>Low noise, more environmentally friendly.</li>
                        </ul>
                </div>
                <div className="Ordinary">
                    <img src={bstandar} alt="72 Cavity PET Preforms Machine" className="Cavity-image"/>
                </div>
                 <p className="Ordinary-text">Powerjet injection molding machines have been widely recognized and verified 
                    by customers for the unique advantages of being “more efficient and energy-saving, more precise and stable,
                     wider scope of application,
                     the longer service life of machine and mold”.</p>
                      <p className="Ordinary-text">In the pursuit of cost optimization and profit maximization, effectively provide customers with continuous competitiveness..</p>

            </div>

        </div>
    );
};

export default Bjstandard;
